import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_URLS } from '../apiConfig';

function Login() {
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [loading, setLoading] = useState(false); // Para feedback visual
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(API_URLS.AUTH, {
      
        nombre_usuario: nombreUsuario,
        contrasena: contrasena
      });

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userRol', response.data.rol);
      navigate('/dashboard');
    } catch (error) {
      alert('Error en el login. Verifica tus credenciales.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

 return (
    <div className="login-page">
      <div className="w-full max-w-[380px] animate-fadeIn flex flex-col items-center">
        
        {/* Logo con color original */}
        <div className="mb-6">
          <img 
            src="/imagenes/sinfondo.png" 
            alt="Logo de la empresa" 
            className="max-w-[430px] h-auto object-contain" // Cambia 130px por el tamaño que desees
          />
        </div>

        {/* Tarjeta del Formulario */}
        <div className="bg-white p-8 md:p-10 rounded-[2rem] shadow-2xl border border-gray-100 w-full">
          <h2 className="text-xl font-extrabold text-gray-800 mb-1 text-center">
            Acceso al Sistema
          </h2>
          <p className="text-gray-400 text-[10px] text-center mb-8 uppercase tracking-[0.2em] font-bold">
            Panel Administrativo
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="flex flex-col">
              <label className="label-modern">Usuario</label>
              <input 
                type="text" 
                value={nombreUsuario} 
                onChange={(e) => setNombreUsuario(e.target.value)} 
                required 
                className="input-modern" 
                placeholder="Nombre de usuario"
              />
            </div>

            <div className="flex flex-col">
              <label className="label-modern">Contraseña</label>
              <input 
                type="password" 
                value={contrasena} 
                onChange={(e) => setContrasena(e.target.value)} 
                required 
                className="input-modern" 
                placeholder="••••••••"
              />
            </div>

            {/* Botón Amarillo a Negro (Más pequeño) */}
            <div className="flex justify-center pt-2">
              <button 
                type="submit" 
                className="btn-corporate w-full md:w-3/4"
                disabled={loading}
              >
                {loading ? 'Entrando...' : 'Iniciar Sesión'}
              </button>
            </div>
          </form>

          <div className="mt-8 pt-6 border-t border-gray-50 text-center text-gray-300">
             <i className="bi bi-shield-lock text-xl"></i>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;